import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private static readonly HTTP_SPINNER_LOADER_TIMEOUT = 300

    blockedRequests: string[] = []
    isLoading = new Subject<boolean>()
    blockSubmit = new Subject<boolean>()
    private endLoading = false

    block(key: string): void {
        this.blockedRequests.push(key)
        this.blockSubmit.next(true)
        this.endLoading = false
        setTimeout(() => {
            if (!this.endLoading) {
                this.isLoading.next(true)
            }
        }, LoaderService.HTTP_SPINNER_LOADER_TIMEOUT)
    }

    unblock(key: string): void {
        const index = this.blockedRequests.indexOf(key, 0)
        if (index > -1) {
            this.blockedRequests.splice(index, 1)
        }
        if (this.blockedRequests.length === 0) {
            this.clear()
        }
    }

    unblockAll(): void {
        this.blockedRequests = []
        this.clear()
    }

    private clear(): void {
        this.isLoading.next(false)
        this.endLoading = true
        this.blockSubmit.next(false)
    }

    isBlocked(key: string): string | undefined {
        return this.blockedRequests.find((blockedRequests) => blockedRequests === key)
    }
}
